import React, { Component } from 'react';
import FullCalendar from '@fullcalendar/react';
import $ from 'jquery';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction'; // needed for dayClick
import listPlugin from '@fullcalendar/list';
import moment from 'moment';
import ExceededMessage from "../components/exceeded_free_trial_message.js"
import Alert from '../components/Alert';

import { getCalendarEvents, getProducts, getSchedules } from '../services/api';

import '@fullcalendar/core/main.css';
import '@fullcalendar/daygrid/main.css';
import allLocales from '@fullcalendar/core/locales-all';

export default class CalendarPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      products: [],
      product: false,
      variant: false,
      firstOccurrence: null,
    };

    this.onSelectProduct = this.onSelectProduct.bind(this);
    this.onSelectVariant = this.onSelectVariant.bind(this);
    this.fetchScheduledProducts = this.fetchScheduledProducts.bind(this);
    this.fetchAnnouncements = this.fetchAnnouncements.bind(this);
    this.eventRender = this.eventRender.bind(this);
    this.viewRender = this.viewRender.bind(this);
    this.refetchEvents = this.refetchEvents.bind(this);
    this.renderImage = this.renderImage.bind(this);
    this.renderIcon = this.renderIcon.bind(this);
  }

  calendarComponentRef = React.createRef();

  async componentDidMount() {
    try {
      const data = await getProducts();
      if (data && data.products) {
        const { products } = data;
        this.setState({ products });
      }
    } catch (e) {
      console.log('error', e);
      throw e;
    }
  }

  fetchScheduledProducts(timeObj, callback) {
    const { start, end } = timeObj;
    const today = new Date();
    const params = {
      start: moment(start).format('YYYY-MM-DD'),
      end: moment(end).format('YYYY-MM-DD'),
      location: '',
      tags: '',
      calendar: true,
    };

    const { product, variant } = this.state,
          { exceededTrialPlan } = this.props;
    if (product) {
      params.products = product.id;
      params.bta_id = '1';
    } else {
      params.handle = '';
    }
    if (variant) {
      params.variant = variant.id;
    } else {
      params.variant = '';
    }
    if (!exceededTrialPlan) {
      getSchedules(params)
        .then((data) => {
          const {schedule} = data;
          const events = schedule.map((item) => {
            const elem = Object.assign(item, {
              start: new Date(
                item.start[0],
                item.start[1] - 1,
                item.start[2],
                item.start[3],
                item.start[4],
                item.start[5],
              ),
              end: new Date(
                item.end[0],
                item.end[1] - 1,
                item.end[2],
                item.end[3],
                item.end[4],
                item.end[5],
              ),
            });

            if (elem.start < today || elem.bookedOut) {
              delete elem.url;
            }
            return elem;
          });

          const {firstOccurrence} = this.state;
          const {first_occurrence} = data;
          if (first_occurrence) {
            const occurrence = new Date(
              first_occurrence[0],
              first_occurrence[1] - 1,
              first_occurrence[2],
              first_occurrence[3],
              first_occurrence[4],
              first_occurrence[5],
            );

            if (!firstOccurrence && !moment(occurrence).isBetween(start, end)) {
              this.setState({firstOccurrence: occurrence});
              const calendarApi = this.calendarComponentRef.current.getApi();
              calendarApi.gotoDate(occurrence);
            }
          }
          callback(events);
        })
        .catch((e) => {
          console.log(e);
          callback([]);
        });
    }
  }

  fetchAnnouncements(timeObj, callback) {
    const { start, end } = timeObj,
          { exceededTrialPlan } = this.props;

    const params = {
      start: moment(start).format('YYYY-MM-DD'),
      end: moment(end).format('YYYY-MM-DD'),
    };

    if (!exceededTrialPlan) {
      getCalendarEvents(params)
        .then((data) => {
          const events = data.events.map(item => ({
            start: new Date(
              item.start[0],
              item.start[1] - 1,
              item.start[2],
              item.start[3],
              item.start[4],
              item.start[5],
            ),
            end: new Date(
              item.end[0],
              item.end[1] - 1,
              item.end[2],
              item.end[3],
              item.end[4],
              item.end[5],
            ),
            allDay: item.all_day,
          }));
          callback(events);
        })
        .catch((e) => {
          console.log(e);
          callback([]);
        });
    }
  }

  renderImage(event, element) {
    const parts = event.image.split('?');
    const image = parts[0];
    const index = image.lastIndexOf('.');
    const ext = image.substr(index);
    const path = image.substr(0, index);
    const div = $('<div>', { class: 'fc-thumb' });
    const img = $('<img>', { src: `${path}_small${ext}?_=${parts[1]}` });

    if (element.find('.fc-list-item-marker').length > 0) {
      element.find('.fc-list-item-marker').empty().append(div.append(img));
    } else {
      element.find('.fc-content').append(div.append(img));
    }
  }

  renderIcon(event, element) {
    const cssClass = `fa ${event.icon}`;
    const i = $('<i>', { class: cssClass, css: { margin: '5px' } });
    element.find('.fc-content').prepend(i);
  }

  viewRender(view, element) {
    window.localStorage.setItem('__bta.calendar-view', view.name);
    window.localStorage.setItem('__bta.calendar-date', view.intervalStart.format());
  }

  eventRender(info) {
    const { event, el } = info;
    const today = new Date();
    const { extendedProps } = event;

    if (!extendedProps) return;

    const element = $(el);
    if (event.end < today) {
      element.addClass('past-event');
    } else if (extendedProps.bookedOut) {
      element.addClass('booked-out');
      element.find('.fc-list-item-title').append($('<br><small>Sold Out!</small>'));
    } else {
      element.find('.fc-list-item-title')
        .append($(`<br><small>${extendedProps.capacity - event.extendedProps.bookingCount} spots left</small>`));
    }

    const { setting } = this.props;
    if (extendedProps.image
      && ((typeof setting.show_image === 'boolean' && setting.show_image)
        || (typeof setting.show_image === 'string' && setting.show_image === 'true'))) {
      this.renderImage(extendedProps, element);
    }

    if (extendedProps.icon
      && ((typeof setting.show_image === 'boolean' && setting.show_image)
        || (typeof setting.show_image === 'string' && setting.show_image === 'true'))) {
      this.renderIcon(extendedProps, element);
    }
  }

  onSelectProduct(e) {
    const { products } = this.state;
    const id = e.target.value;
    const that = this;

    if (id === 'all') {
      return this.setState({ product: false, variant: false }, () => {
        that.refetchEvents();
      });
    }

    const product = products.find(e => e.id === parseInt(id, 10));
    if (product) {
      this.setState({ product }, () => {
        that.refetchEvents();
      });
    }
  }

  refetchEvents() {
    const calendarApi = this.calendarComponentRef.current.getApi();
    calendarApi.refetchEvents();
  }

  onSelectVariant(e) {
    const { product } = this.state;
    const id = e.target.value;

    const that = this;

    if (id === 'all') {
      return this.setState({ variant: false }, () => {
        that.refetchEvents();
      });
    }

    const variant = product.variants.find(e => e.id === parseInt(id, 10));
    if (variant) {
      this.setState({ variant }, () => {
        that.refetchEvents();
      });
    }

    return true;
  }

  renderButtonStyle() {
    const { style } = this.props;
    const bgc = style.button && style.button.backgroundColor ? style.button.backgroundColor : 'black';
    const fc = style.button && style.button.color ? style.button.color : 'white';

    return (
      <style dangerouslySetInnerHTML={{__html: `
        .bta-calendar-widget .fc-button {
          color: ${fc} !important;
          background-color: ${bgc} !important;
        };
      `}}
      />
    )
  }

  render() {
    const {
      products, product,
    } = this.state;
    const { style, exceededTrialPlan } = this.props;
    const defaultView = window.innerWidth > 514 ? 'dayGridMonth' : 'listMonth';

    let region = this.props.defaultSetting.region
    if (region == '') { region = 'en-US'}

    return (
      <div style={style.body}>
        {this.renderButtonStyle()}
        <h3 style={{...style.title}}>Events Calendar</h3>

        {exceededTrialPlan &&
          <Alert unclosed={true} messages={[<ExceededMessage/>]} type="exceeded-trial-plan" />
        }

        { products.length > 0
          && (
          <div>
            <label htmlFor="bta-product-select" className="calendar-label">Product</label>
            <select
              id="bta-product-select"
              className="calendar-product-select"
              onChange={this.onSelectProduct}
            >
              <option value="all">All products</option>
              { products.map((p, i) => (
                <option value={p.id} key={i}>{ p.title }</option>
              ))
              }
            </select>
            { product
            && (
              <div id="bta-variant-select-wrap">
                <label htmlFor="bta-variant-select" className="calendar-label">Type</label>
                <select
                  className="calendar-product-select"
                  id="bta-variant-select"
                  onChange={this.onSelectVariant}
                >
                  <option value="all">All variants</option>
                  { product.variants.map((v, i) => (
                    <option value={v.id} key={i}>{ v.title }</option>
                  ))
                  }
                </select>
              </div>
            )
            }
          </div>
          )
        }

        <div className="fullcalendar-wrapper bta-calendar-widget">
          <FullCalendar
            defaultView={defaultView}
            contentHeight="auto"
            header={{
              left: 'prev,next today',
              center: 'title',
              right: 'dayGridMonth,timeGridWeek,timeGridDay,listMonth',
            }}
            plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin, listPlugin]}
            ref={this.calendarComponentRef}
            loading={(isLoading) => {
              if (isLoading) {
                $('#bta-loading').fadeIn();
              } else {
                $('#bta-loading').fadeOut();
              }
            }}
            eventSources={[
              { events: this.fetchScheduledProducts },
              { events: this.fetchAnnouncements },
            ]}
            eventRender={this.eventRender}
            allDaySlot={false}
            locales={allLocales}
            locale={region}
          />
          <span id="bta-loading" className="loading" style={{ display: 'none', float: 'left' }}>Loading...</span>
        </div>
      </div>
    );
  }
}
